import {createStateMaker} from '@shared/helpers/object'

import {APIStatus} from '@web/core/constants'

import {AgreementState} from '../interfaces'

export const getInitialState = (): AgreementState => ({
    mallContract: false,
    thirdPeople: false,
    personalDataCrossBorderTransfer: null,
    customOrder: false,
    preOrder: false,
    enabled: false,
    selected: {
        mallContract: false,
        thirdPeople: false,
        customOrder: false,
        preOrder: false,
        personalDataCrossBorderTransfer: false,
        familyPay: false,
        booking: false,
        shoppingSubscription: false,
    },
    openBankingAgreed: false,
    openBankingAgreeApiStatus: APIStatus.IDLE,
    familyPayMinorAgreed: false,
    shoppingSubscription: false,
    replaceExistingPaymentMethod: false,
})

export const makeMock = createStateMaker<AgreementState>(getInitialState)
